import {
  getTrackingData,
  mapRouteToName,
  mapRouteToSubCategory,
  flushComponent,
} from '../helpers/adobe';
import { mergeDataFromEvent } from '../helpers/dataLayer';

export const PRE_SEND_TRACKING = 'PRE_SEND_TRACKING';
export const SEND_TRACKING = 'SEND_TRACKING';

function dispatchPreSendTracking(match, otherData) {
  return {
    type: PRE_SEND_TRACKING,
    payload: { match, otherData },
  };
}

function dispatchSendTracking(data) {
  document.dispatchEvent(new CustomEvent('c-tracking-log-page', {
    detail: data,
    bubbles: true,
  }));

  return {
    type: SEND_TRACKING,
    payload: data,
  };
}

export const dispatchSendTransaction = (data = {}) => {
  const transaction = {
    eventName: data.name || 'Click',
    eventAction: data.action,
    eventMethod: 'self-ServiceTransaction',
    transaction: {
      attributes: {
        selfServiceTransactions: data.transaction,
      },
    },
  };

  const dispatcher = document.getElementById('root') || document;

  dispatcher.dispatchEvent(new CustomEvent('c-tracking-log-dom', {
    detail: transaction,
    bubbles: true,
  }));

  return {
    type: SEND_TRACKING,
    payload: {
      event: 'c-tracking-log-dom',
      data: transaction,
    },
  };
};


export const sendPageloadEvent = (match = {}, eventData = {}) => async (dispatch, getState) => {
  if (!match.isExact) return false; // do not send analytics for parent components
  // yield execution briefly to allow templates to include impressions
  await new Promise(r => setTimeout(r, 0));
  // Wait for any components before fetching current state
  const component = await flushComponent(eventData.component);
  const {
    account: { data: accountData },
    auth: { macaroon, lite },
  } = getState();
  const digitalData = getTrackingData(accountData, macaroon, lite);
  const trackingData = mergeDataFromEvent({
    ...eventData,
    component,
  }, digitalData);
  // always make sure we have match
  trackingData.page.pageInfo.screenName = mapRouteToName(match);

  const subCategory = mapRouteToSubCategory(match);
  if (subCategory) {
    trackingData.page.category.subCategory2 = subCategory;
  }

  // send to the store before mixing with digitalData
  dispatch(dispatchPreSendTracking(match, eventData));

  return dispatch(dispatchSendTracking(trackingData));
};


/*
data = {
  name: String, // name of the transaction
  action: String, // The button text that was clicked to trigger the transaction, e.g. 'Submit'
  transaction: String // The transaction from analytics specification,
                        e.g. 'myaccount:appointments:schedulenewconfirm'
}
*/
export const sendTransaction = data => dispatch => dispatch(dispatchSendTransaction(data));
